import { io } from "socket.io-client";

// const notificationsSocket = io("http://localhost:5000") 
const notificationsSocket = io(process.env.REACT_APP_NODE_LOCAL_URL) 
const ws = new WebSocket("https://apollo-python-backend.octalooptechnologies.com/ws/ws");

//   {
//   transports: ['websocket', 'polling'],
//   withCredentials: true, // Make sure credentials are sent along with the request
// }




export { notificationsSocket, ws };
